import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

// -------------------------------------------------------


class ReportMembers extends React.Component {
  render() {
    let data = this.props.data;
    
    let list = Utils.createObjectToArray(data.workflow.influencers);
    list.map((d) => {
      d.view_order = 0;
      
      d.reports = [];
      d.contents_targets = [];
      
      // 投稿コンテンツ
      d.post_contents.map((c) => {
        let report = {};
        data.report.list.map((r) => { if( c.id == r.contents_id ) report = r; });
        
        d.contents_targets.push(Object.assign(c, { report: report }));
        
        if( Object.keys(report).length > 0 ){
          d.reports.push(report);
        } else {
          d.view_order += 1;
        }
      });
      
      if( d.post_contents.length > 0 ) d.view_order += 1;
      
      // 完了フラグ
      d.contents_complete = (d.contents_targets.length > 0 && d.reports.length == d.contents_targets.length);
      
      // 確認度が高い投稿
      d.request_action = CastingCommon.getRequestAction(data, d.insta_user_id);
      if( d.request_action == 'report_select' && d.contents_complete == false ) d.view_order += 99;
      
      return d;
    });
    list = Utils.sort(list, 'view_order');
    
    // 存在しない場合
    if( list.length == 0 ){
      return (
        <div className="report-members">
          <div className="report-none">インフルエンサーが登録されていません</div>
        </div>
      );
    }
    
    return (
      <div className="report-members">
        <ReportMembersList data={data} list={list} contents_type="report" title="実際の投稿を設定してください" />
        <ReportMembersList data={data} list={list} contents_type="contents" title="投稿種別を設定してください" />
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportMembersList extends React.Component {
  render() {
    let data = this.props.data;
    let list = this.props.list.filter((d) => {
      if( this.props.contents_type == 'report' && d.contents_targets.length > 0 ) return d;
      if( this.props.contents_type == 'contents' && d.contents_targets.length == 0 ) return d;
    });
    
    return (
      <div className="report-members-contents">
        <h3>{this.props.title}</h3>
        
        <ul className="members">
          { list.map((d, key) => {
            let flg = (d.contents_complete === true) ? 'on' : 'off';
            
            let pop_alert = CastingCommon.getReportSelectTarget(data, d.insta_user_id);
            
            // プロフィール
            let profile = (
              <div className="profile">
                <p>
                  <i className={'material-icons '+ flg}>check_circle</i><img src={d.thumbnail} />{d.insta_id}
                  { (pop_alert) && <span className="profile-dot" /> }
                </p>
              </div>
            );
            
            if( d.contents_targets.length == 0){
              return (
                <li key={key} onClick={data.event.showPostContents.bind(this, data.project.id, d.insta_user_id)}>
                  {profile}
                  <div className="contents-targets"><p className="none">投稿種別を設定していません</p></div>
                </li>
              );
            } else {
              return (
                <li key={key} onClick={data.event.showReportCandidateModal.bind(this, data.project.id, d.insta_user_id, null)}>
                  {profile}
                  <ReportMembersContents array={d.contents_targets} />
                </li>
              );
            }
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportMembersContents extends React.Component {
  render() {
    let array = this.props.array;
    if( array.length == 0 ) return null;
    
    return (
      <div className="contents-targets">
        { array.map((d, key) => {
          return (
            <div key={key} className="contents-targets-item">
              <h6>{d.name}</h6>
              
              { (Object.keys(d.report).length == 0)
                ? <h2>-</h2>
                : <img src={d.report.thumbnail} />
              }
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportMembers;